function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BaseWalletAdapter, LoginStateEnum, makeError, ERR_CODE, ConnectedWallet, utils, enhancedLocalStorage } from '@aelf-web-login/wallet-adapter-base';
import { MethodsWallet } from '@portkey/provider-types';
import { getContractBasic } from '@portkey/contracts';
import detectDiscoverProvider from "./detectProvider";
import checkSignatureParams from "./signatureParams";
import { zeroFill, openPageInDiscover } from "./utils";
var isPortkeyApp = utils.isPortkeyApp,
  isMobileDevices = utils.isMobileDevices;
// autoRequestAccount: true,
// autoLogoutOnAccountMismatch: true,
// autoLogoutOnChainMismatch: true,
// autoLogoutOnDisconnected: true,
// autoLogoutOnNetworkMismatch: true,
// onClick: continueDefaultBehaviour => {
//   continueDefaultBehaviour();
// },
// onPluginNotFound: openStore => {
//   console.log(234);
//   openStore();
// }

export var PortkeyDiscoverName = 'PortkeyDiscover';
export var PortkeyDiscoverWallet = /*#__PURE__*/function (_BaseWalletAdapter) {
  _inherits(PortkeyDiscoverWallet, _BaseWalletAdapter);
  var _super = _createSuper(PortkeyDiscoverWallet);
  function PortkeyDiscoverWallet(config) {
    var _this;
    _classCallCheck(this, PortkeyDiscoverWallet);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "name", PortkeyDiscoverName);
    _defineProperty(_assertThisInitialized(_this), "icon", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzFGMUYyMSIgZD0iTTcuNjI5IDMuMzY4Yy0xLjU3Mi42ODktMi43MSAyLjU1OS0yLjE1IDQuNjM1LjM5NCAxLjE0OCAxLjE0NSAxLjk3NiAyLjMyMyAyLjM5NSAyLjA2MS43MzEgNC4yNDgtLjkgMy45MzUtMi45OTItLjEzMy0uODktLjcwNC0xLjQ3Ny0xLjQ4Ni0xLjY5NS0uNjY4LS4xNTYtMS4zNDMtLjA0LTEuODI5LjQyNGExLjUwNCAxLjUwNCAwIDAgMC0uNDI4IDEuMzczYy4xLjMzLjI2LjUzNi42NjYuNjM0LjIyNC4wNTQuNTEgMCAuNTk4LS4yMDIuMDU5LS4xMzcuMDA0LS4yNS0uMDM3LS4zNzktLjExLS4zNTMtLjAzOC0uNTU2LjE1NC0uNzMuMjU5LS4yNTcuNjk4LS4yNi45NzYtLjA2NC4zNTkuMTgzLjY0NC43NjcuMzA4IDEuNjY0LS4zODQuOTI0LTEuMzg1IDEuMjAyLTIuMzE4Ljk2LTEuMzUtLjM1LTIuMDg1LTEuODgzLTEuNzYyLTMuMTAyLjUzOC0yLjAyOSAyLjc5OS0yLjY1NyA0LjY3OS0xLjcyNiAxLjI2OS43MTUgMi4wNjMgMS44NjcgMi4wNCAzLjQzMy0uMSAyLjU3NS0yLjcwNCA0LjQ3NC01LjMxIDMuOTc3YTUuMjc5IDUuMjc5IDAgMCAxLTQuMjItNS4wMzMgNS40MjcgNS40MjcgMCAwIDEgLjU3NC0yLjUzNkM1LjM2NCAyLjQ3NCA3LjE0IDEuNTcgOS40IDEuNDM0Yy41OTMtLjAzNSAxLjAyMyAwIDEuNzczLjA3NS0uMDMtLjAxNC0uMS0uMDQ3LS4xNzEtLjA3NGE2LjYzNSA2LjYzNSAwIDAgMC0zLjMwOS0uMzY3IDYuNjkgNi42OSAwIDAgMC0xLjkxNS41ODRjLS4yNTQuMDktLjI5Mi0uMTI2LS40ODgtLjI5LS4wOTItLjA3Ni0uMDgzLjAyLS4wODMuMDIuMDguMzgxLS4wOTcuNTczLS4xMjQuNTkyYTIuMDc5IDIuMDc5IDAgMCAxLS40ODIuMzMyYy0uMzI2LjE0Mi0uNDc4LS4wOTItLjczNy0uMjI1LS4xNzgtLjA5LS4xMDguMDYtLjEwOC4wNi4yMi40MzcuMDY2LjgzOS4wMy45MDItLjE1Mi4yMi0uMjc4LjM3NS0uNDgzLjU2LS4zNTkuMzI1LS43ODUuMDEyLS45MTItLjAzNi0uMjQtLjA4OS0uMDY3LjExNS0uMDY3LjExNS4wOTYuMTI3LjQ0Ljg1Ni4zMzMgMS4wODZhNi43MzcgNi43MzcgMCAwIDAtLjUzOSA0LjE2NWMxIDUuMDA0IDYuNjg4IDYuNzQgMTAuMjI4IDQuMzIxIDEuODc5LTEuMzg3IDIuNTItMy41NDggMi41NC00Ljg5NS4wMjItMS4zNDctLjMxNy0yLjMyNy0uOTQyLTMuMjAxLTEuNDg0LTIuMDc0LTQuMTY4LTIuNzMyLTYuMzE0LTEuNzlaIi8+PC9zdmc+');
    _defineProperty(_assertThisInitialized(_this), "darkIcon", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTcuNjI5IDMuMzY4Yy0xLjU3Mi42ODktMi43MSAyLjU1OS0yLjE1IDQuNjM1LjM5NCAxLjE0OCAxLjE0NSAxLjk3NiAyLjMyMyAyLjM5NSAyLjA2MS43MzEgNC4yNDgtLjkgMy45MzUtMi45OTItLjEzMy0uODktLjcwNC0xLjQ3Ny0xLjQ4Ni0xLjY5NS0uNjY4LS4xNTYtMS4zNDMtLjA0LTEuODI5LjQyNGExLjUwNCAxLjUwNCAwIDAgMC0uNDI4IDEuMzczYy4xLjMzLjI2LjUzNi42NjYuNjM0LjIyNC4wNTQuNTEgMCAuNTk4LS4yMDIuMDU5LS4xMzcuMDA0LS4yNS0uMDM3LS4zNzktLjExLS4zNTMtLjAzOC0uNTU2LjE1NC0uNzMuMjU5LS4yNTcuNjk4LS4yNi45NzYtLjA2NC4zNTkuMTgzLjY0NC43NjcuMzA4IDEuNjY0LS4zODQuOTI0LTEuMzg1IDEuMjAyLTIuMzE4Ljk2LTEuMzUtLjM1LTIuMDg1LTEuODgzLTEuNzYyLTMuMTAyLjUzOC0yLjAyOSAyLjc5OS0yLjY1NyA0LjY3OS0xLjcyNiAxLjI2OS43MTUgMi4wNjMgMS44NjcgMi4wNCAzLjQzMy0uMSAyLjU3NS0yLjcwNCA0LjQ3NC01LjMxIDMuOTc3YTUuMjc5IDUuMjc5IDAgMCAxLTQuMjItNS4wMzMgNS40MjcgNS40MjcgMCAwIDEgLjU3NC0yLjUzNkM1LjM2NCAyLjQ3NCA3LjE0IDEuNTcgOS40IDEuNDM0Yy41OTMtLjAzNSAxLjAyMyAwIDEuNzczLjA3NS0uMDMtLjAxNC0uMS0uMDQ3LS4xNzEtLjA3NGE2LjYzNSA2LjYzNSAwIDAgMC0zLjMwOS0uMzY3IDYuNjkgNi42OSAwIDAgMC0xLjkxNS41ODRjLS4yNTQuMDktLjI5Mi0uMTI2LS40ODgtLjI5LS4wOTItLjA3Ni0uMDgzLjAyLS4wODMuMDIuMDguMzgxLS4wOTcuNTczLS4xMjQuNTkyYTIuMDc5IDIuMDc5IDAgMCAxLS40ODIuMzMyYy0uMzI2LjE0Mi0uNDc4LS4wOTItLjczNy0uMjI1LS4xNzgtLjA5LS4xMDguMDYtLjEwOC4wNi4yMi40MzcuMDY2LjgzOS4wMy45MDItLjE1Mi4yMi0uMjc4LjM3NS0uNDgzLjU2LS4zNTkuMzI1LS43ODUuMDEyLS45MTItLjAzNi0uMjQtLjA4OS0uMDY3LjExNS0uMDY3LjExNS4wOTYuMTI3LjQ0Ljg1Ni4zMzMgMS4wODZhNi43MzcgNi43MzcgMCAwIDAtLjUzOSA0LjE2NWMxIDUuMDA0IDYuNjg4IDYuNzQgMTAuMjI4IDQuMzIxIDEuODc5LTEuMzg3IDIuNTItMy41NDggMi41NC00Ljg5NS4wMjItMS4zNDctLjMxNy0yLjMyNy0uOTQyLTMuMjAxLTEuNDg0LTIuMDc0LTQuMTY4LTIuNzMyLTYuMzE0LTEuNzlaIi8+PC9zdmc+');
    _defineProperty(_assertThisInitialized(_this), "_loginState", void 0);
    _defineProperty(_assertThisInitialized(_this), "_wallet", void 0);
    _defineProperty(_assertThisInitialized(_this), "_detectProvider", void 0);
    _defineProperty(_assertThisInitialized(_this), "_chainId", void 0);
    _defineProperty(_assertThisInitialized(_this), "_config", void 0);
    _this._loginState = LoginStateEnum.INITIAL;
    _this._wallet = null;
    _this._detectProvider = null;
    _this._chainId = config.chainId;
    _this._config = config;
    if (typeof window !== 'undefined') {
      _this.detect().then(function () {
        _this.autoRequestAccountHandler();
      });
    }
    return _this;
  }
  _createClass(PortkeyDiscoverWallet, [{
    key: "loginState",
    get: function get() {
      return this._loginState;
    }
  }, {
    key: "wallet",
    get: function get() {
      return this._wallet;
    }
  }, {
    key: "autoRequestAccountHandler",
    value: function () {
      var _autoRequestAccountHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var canLoginEargly;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this._config.autoRequestAccount) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              canLoginEargly = enhancedLocalStorage.getItem(ConnectedWallet) === this.name || isPortkeyApp();
              if (!canLoginEargly) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return this.loginEagerly();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function autoRequestAccountHandler() {
        return _autoRequestAccountHandler.apply(this, arguments);
      }
      return autoRequestAccountHandler;
    }() // private executeOnce<T extends (...args: any) => any>(fn: T) {
    //   if (typeof fn !== 'function') {
    //     throw new Error('please pass a function');
    //   }
    //   let result: ReturnType<T>;
    //   return (...rest: any) => {
    //     if (fn) {
    //       result = fn.apply(this, rest);
    //       fn = null as any;
    //     }
    //     return result;
    //   };
    // }
  }, {
    key: "detect",
    value: function () {
      var _detect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$_detectProvider;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!((_this$_detectProvider = this._detectProvider) !== null && _this$_detectProvider !== void 0 && _this$_detectProvider.isConnected())) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", this._detectProvider);
            case 2:
              _context2.next = 4;
              return detectDiscoverProvider();
            case 4:
              this._detectProvider = _context2.sent;
              if (!this._detectProvider) {
                _context2.next = 12;
                break;
              }
              if (this._detectProvider.isPortkey) {
                _context2.next = 8;
                break;
              }
              throw makeError(ERR_CODE.NOT_PORTKEY);
            case 8:
              this.listenProviderEvents();
              return _context2.abrupt("return", this._detectProvider);
            case 12:
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function detect() {
        return _detect.apply(this, arguments);
      }
      return detect;
    }()
  }, {
    key: "onAccountsSuccess",
    value: function () {
      var _onAccountsSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(provider, accounts) {
        var nickName, address;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              nickName = 'Wallet 01';
              address = accounts[this._chainId][0].split('_')[1];
              _context3.prev = 2;
              _context3.next = 5;
              return provider.request({
                method: 'wallet_getWalletName'
              });
            case 5:
              nickName = _context3.sent;
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
              console.warn(_context3.t0);
            case 11:
              this._wallet = {
                address: address,
                extraInfo: {
                  accounts: accounts,
                  nickName: nickName,
                  provider: provider
                }
              };
              this._loginState = LoginStateEnum.CONNECTED;
              enhancedLocalStorage.setItem(ConnectedWallet, this.name);
              this.emit('connected', this._wallet);
              return _context3.abrupt("return", this._wallet);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 8]]);
      }));
      function onAccountsSuccess(_x, _x2) {
        return _onAccountsSuccess.apply(this, arguments);
      }
      return onAccountsSuccess;
    }()
  }, {
    key: "onAccountsFail",
    value: function onAccountsFail(err) {
      throw err;
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var provider, chainId, network, accounts;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(isMobileDevices() && !isPortkeyApp())) {
                _context4.next = 3;
                break;
              }
              openPageInDiscover(undefined, undefined);
              return _context4.abrupt("return");
            case 3:
              _context4.prev = 3;
              if (this._detectProvider) {
                _context4.next = 6;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 6:
              provider = this._detectProvider;
              chainId = this._chainId;
              this._loginState = LoginStateEnum.CONNECTING;
              _context4.next = 11;
              return provider.request({
                method: 'network'
              });
            case 11:
              network = _context4.sent;
              if (!(network !== this._config.networkType)) {
                _context4.next = 15;
                break;
              }
              this.onAccountsFail(makeError(ERR_CODE.NETWORK_TYPE_NOT_MATCH));
              return _context4.abrupt("return");
            case 15:
              _context4.next = 17;
              return provider.request({
                method: 'accounts'
              });
            case 17:
              accounts = _context4.sent;
              if (!(accounts[chainId] && accounts[chainId].length > 0)) {
                _context4.next = 22;
                break;
              }
              _context4.next = 21;
              return this.onAccountsSuccess(provider, accounts);
            case 21:
              return _context4.abrupt("return", _context4.sent);
            case 22:
              _context4.next = 24;
              return provider.request({
                method: 'requestAccounts'
              });
            case 24:
              accounts = _context4.sent;
              if (!(accounts[chainId] && accounts[chainId].length > 0)) {
                _context4.next = 31;
                break;
              }
              _context4.next = 28;
              return this.onAccountsSuccess(provider, accounts);
            case 28:
              return _context4.abrupt("return", _context4.sent);
            case 31:
              this.onAccountsFail(makeError(ERR_CODE.ACCOUNTS_IS_EMPTY));
              return _context4.abrupt("return");
            case 33:
              _context4.next = 40;
              break;
            case 35:
              _context4.prev = 35;
              _context4.t0 = _context4["catch"](3);
              this._loginState = LoginStateEnum.INITIAL;
              this.emit('error', makeError(ERR_CODE.DISCOVER_LOGIN_FAIL, _context4.t0));
              return _context4.abrupt("return");
            case 40:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 35]]);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "loginEagerly",
    value: function () {
      var _loginEagerly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var provider, chainId, _yield$provider$reque, isUnlocked, network, accounts;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              if (this._detectProvider) {
                _context5.next = 3;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 3:
              provider = this._detectProvider;
              chainId = this._chainId;
              this._loginState = LoginStateEnum.CONNECTING;
              _context5.next = 8;
              return provider.request({
                method: 'wallet_getWalletState'
              });
            case 8:
              _yield$provider$reque = _context5.sent;
              isUnlocked = _yield$provider$reque.isUnlocked;
              if (isUnlocked) {
                _context5.next = 12;
                break;
              }
              return _context5.abrupt("return");
            case 12:
              _context5.next = 14;
              return provider.request({
                method: 'network'
              });
            case 14:
              network = _context5.sent;
              if (!(network !== this._config.networkType)) {
                _context5.next = 18;
                break;
              }
              this.onAccountsFail(makeError(ERR_CODE.NETWORK_TYPE_NOT_MATCH));
              return _context5.abrupt("return");
            case 18:
              _context5.next = 20;
              return provider.request({
                method: 'accounts'
              });
            case 20:
              accounts = _context5.sent;
              if (!(accounts[chainId] && accounts[chainId].length > 0)) {
                _context5.next = 26;
                break;
              }
              _context5.next = 24;
              return this.onAccountsSuccess(provider, accounts);
            case 24:
              _context5.next = 27;
              break;
            case 26:
              this.onAccountsFail(makeError(ERR_CODE.DISCOVER_LOGIN_EAGERLY_FAIL));
            case 27:
              _context5.next = 32;
              break;
            case 29:
              _context5.prev = 29;
              _context5.t0 = _context5["catch"](0);
              this.emit('error', makeError(ERR_CODE.DISCOVER_LOGIN_EAGERLY_FAIL, _context5.t0));
            case 32:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 29]]);
      }));
      function loginEagerly() {
        return _loginEagerly.apply(this, arguments);
      }
      return loginEagerly;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this._wallet = null;
              this._loginState = LoginStateEnum.INITIAL;
              enhancedLocalStorage.removeItem(ConnectedWallet);
              this.emit('disconnected');
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "getSignature",
    value: function () {
      var _getSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
        var signInfo, signedMsgObject, signedMsgString;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              checkSignatureParams(params);
              if (this._wallet) {
                _context7.next = 3;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 3:
              if (this._detectProvider) {
                _context7.next = 5;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 5:
              signInfo = params.signInfo;
              _context7.next = 8;
              return this._detectProvider.request({
                method: 'wallet_getSignature',
                payload: {
                  data: signInfo || params.hexToBeSign
                }
              });
            case 8:
              signedMsgObject = _context7.sent;
              signedMsgString = [zeroFill(signedMsgObject.r), zeroFill(signedMsgObject.s), "0".concat(signedMsgObject.recoveryParam.toString())].join('');
              return _context7.abrupt("return", {
                error: 0,
                errorMessage: '',
                signature: signedMsgString,
                from: 'discover'
              });
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getSignature(_x3) {
        return _getSignature.apply(this, arguments);
      }
      return getSignature;
    }()
  }, {
    key: "getAccountByChainId",
    value: function () {
      var _getAccountByChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(chainId) {
        var _this$_wallet$extraIn, _accounts$chainId, _accounts$chainId2;
        var accounts;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this._wallet) {
                _context8.next = 2;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 2:
              if (this._detectProvider) {
                _context8.next = 4;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 4:
              accounts = (_this$_wallet$extraIn = this._wallet.extraInfo) === null || _this$_wallet$extraIn === void 0 ? void 0 : _this$_wallet$extraIn.accounts;
              if (!(!accounts[chainId] || ((_accounts$chainId = accounts[chainId]) === null || _accounts$chainId === void 0 ? void 0 : _accounts$chainId.length) === 0)) {
                _context8.next = 9;
                break;
              }
              _context8.next = 8;
              return this._detectProvider.request({
                method: 'accounts'
              });
            case 8:
              accounts = _context8.sent;
            case 9:
              return _context8.abrupt("return", (_accounts$chainId2 = accounts[chainId]) === null || _accounts$chainId2 === void 0 ? void 0 : _accounts$chainId2[0]);
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAccountByChainId(_x4) {
        return _getAccountByChainId.apply(this, arguments);
      }
      return getAccountByChainId;
    }()
  }, {
    key: "getWalletSyncIsCompleted",
    value: function () {
      var _getWalletSyncIsCompleted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(chainId) {
        var getOriginalAddress, _this$_detectProvider2, status, address;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this._wallet) {
                _context9.next = 2;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 2:
              if (this._detectProvider) {
                _context9.next = 4;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 4:
              getOriginalAddress = utils.getOriginalAddress;
              _context9.prev = 5;
              _context9.next = 8;
              return (_this$_detectProvider2 = this._detectProvider) === null || _this$_detectProvider2 === void 0 ? void 0 : _this$_detectProvider2.request({
                method: MethodsWallet.GET_WALLET_MANAGER_SYNC_STATUS,
                payload: {
                  chainId: chainId
                }
              });
            case 8:
              status = _context9.sent;
              if (!status) {
                _context9.next = 16;
                break;
              }
              _context9.next = 12;
              return this.getAccountByChainId(chainId);
            case 12:
              address = _context9.sent;
              return _context9.abrupt("return", getOriginalAddress(address));
            case 16:
              return _context9.abrupt("return", false);
            case 17:
              _context9.next = 22;
              break;
            case 19:
              _context9.prev = 19;
              _context9.t0 = _context9["catch"](5);
              return _context9.abrupt("return", false);
            case 22:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[5, 19]]);
      }));
      function getWalletSyncIsCompleted(_x5) {
        return _getWalletSyncIsCompleted.apply(this, arguments);
      }
      return getWalletSyncIsCompleted;
    }()
  }, {
    key: "listenProviderEvents",
    value: function listenProviderEvents() {
      var _this2 = this;
      if (!this._detectProvider) {
        return;
      }
      var onDisconnected = function onDisconnected(error) {
        if (!_this2._wallet) return;
        if (_this2._config.autoLogoutOnDisconnected) {
          _this2.logout();
        }
      };
      var onNetworkChanged = function onNetworkChanged(networkType) {
        if (networkType !== _this2._config.networkType) {
          if (_this2._config.autoLogoutOnNetworkMismatch) {
            _this2.logout();
          }
        }
      };
      var onAccountsChanged = function onAccountsChanged(accounts) {
        if (!_this2._wallet) return;
        var chainId = _this2._chainId;
        if (!accounts[chainId] || accounts[chainId].length === 0 || accounts[chainId].find(function (addr) {
          return addr !== _this2._wallet.address;
        })) {
          if (_this2._config.autoLogoutOnAccountMismatch) {
            _this2.logout();
          }
        }
      };
      var onChainChanged = function onChainChanged(chainIds) {
        if (chainIds.find(function (id) {
          return id === _this2._chainId;
        })) {
          if (_this2._config.autoLogoutOnChainMismatch) {
            _this2.logout();
          }
        }
      };
      var discoverEventsMap = {
        disconnected: onDisconnected,
        networkChanged: onNetworkChanged,
        accountsChanged: onAccountsChanged,
        chainChanged: onChainChanged
      };
      Object.keys(discoverEventsMap).forEach(function (ele) {
        var _this2$_detectProvide;
        (_this2$_detectProvide = _this2._detectProvider) === null || _this2$_detectProvide === void 0 || _this2$_detectProvide.on(ele, discoverEventsMap[ele]);
      });
    }
  }, {
    key: "getContract",
    value: function () {
      var _getContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(chainId, contractAddress) {
        var chain;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (this._wallet) {
                _context10.next = 2;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 2:
              if (this._detectProvider) {
                _context10.next = 4;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 4:
              _context10.next = 6;
              return this._detectProvider.getChain(chainId);
            case 6:
              chain = _context10.sent;
              return _context10.abrupt("return", getContractBasic({
                contractAddress: contractAddress,
                chainProvider: chain
              }));
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getContract(_x6, _x7) {
        return _getContract.apply(this, arguments);
      }
      return getContract;
    }()
  }, {
    key: "callSendMethod",
    value: function () {
      var _callSendMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref) {
        var chainId, contractAddress, methodName, args, sendOptions, finalChainId, contract, rs;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              chainId = _ref.chainId, contractAddress = _ref.contractAddress, methodName = _ref.methodName, args = _ref.args, sendOptions = _ref.sendOptions;
              if (this._wallet) {
                _context11.next = 3;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 3:
              if (this._detectProvider) {
                _context11.next = 5;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 5:
              if (contractAddress) {
                _context11.next = 7;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 7:
              finalChainId = chainId || this._chainId;
              _context11.next = 10;
              return this.getContract(finalChainId, contractAddress);
            case 10:
              contract = _context11.sent;
              rs = contract.callSendMethod(methodName, this._wallet.address, args, sendOptions);
              return _context11.abrupt("return", rs);
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function callSendMethod(_x8) {
        return _callSendMethod.apply(this, arguments);
      }
      return callSendMethod;
    }()
  }, {
    key: "callViewMethod",
    value: function () {
      var _callViewMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref2) {
        var chainId, contractAddress, methodName, args, finalChainId, contract, rs;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              chainId = _ref2.chainId, contractAddress = _ref2.contractAddress, methodName = _ref2.methodName, args = _ref2.args;
              if (this._wallet) {
                _context12.next = 3;
                break;
              }
              throw makeError(ERR_CODE.DISCOVER_NOT_CONNECTED);
            case 3:
              if (this._detectProvider) {
                _context12.next = 5;
                break;
              }
              throw makeError(ERR_CODE.WITHOUT_DETECT_PROVIDER);
            case 5:
              if (contractAddress) {
                _context12.next = 7;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 7:
              finalChainId = chainId || this._chainId;
              _context12.next = 10;
              return this.getContract(finalChainId, contractAddress);
            case 10:
              contract = _context12.sent;
              rs = contract.callViewMethod(methodName, args);
              return _context12.abrupt("return", rs);
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function callViewMethod(_x9) {
        return _callViewMethod.apply(this, arguments);
      }
      return callViewMethod;
    }()
  }]);
  return PortkeyDiscoverWallet;
}(BaseWalletAdapter);